export const ADD_AFSTEREO_DATE = 'ADD_AFSTEREO_DATE';
export const SUBTRACT_AFSTEREO_DATE = 'SUBTRACT_AFSTEREO_DATE';

export const SET_AFSTEREO_DATE = 'SET_AFSTEREO_DATE';
export const SET_AFSTEREO_PERIOD = 'SET_AFSTEREO_PERIOD';
export const SET_AFSTEREO_STATION = 'SET_AFSTEREO_STATION';

export const GET_AFSTEREO_CHARTS_REQUEST = 'GET_AFSTEREO_CHARTS_REQUEST';
export const GET_AFSTEREO_CHARTS_FAILURE = 'GET_AFSTEREO_CHARTS_FAILURE';
export const GET_AFSTEREO_CHARTS_SUCCESS = 'GET_AFSTEREO_CHARTS_SUCCESS';

export const GET_AFSTEREO_MAIN_CHART_REQUEST = 'GET_AFSTEREO_MAIN_CHART_REQUEST';
export const GET_AFSTEREO_MAIN_CHART_FAILURE = 'GET_AFSTEREO_MAIN_CHART_FAILURE';
export const GET_AFSTEREO_MAIN_CHART_SUCCESS = 'GET_AFSTEREO_MAIN_CHART_SUCCESS';

export const GET_AFSTEREO_STATIONS_REQUEST = 'GET_AFSTEREO_STATIONS_REQUEST';
export const GET_AFSTEREO_STATIONS_FAILURE = 'GET_AFSTEREO_STATIONS_FAILURE';
export const GET_AFSTEREO_STATIONS_SUCCESS = 'GET_AFSTEREO_STATIONS_SUCCESS';

export const RESET_AFSTEREO_STATIONS_AREA = 'RESET_AFSTEREO_STATIONS_AREA';



// WEBPACK FOOTER //
// ./src/store/modules/afstereo/mutation-types.js